import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {CrudComponent} from '../../../../../shared/components/crud/crud.component';
import {BaseResponse} from '../../../../../shared/models/respose/BaseResponse';
import {PaginatedDataResponse} from '../../../../../shared/models/respose/PaginatedDataResponse';
import {Source} from '../../../../../shared/models/Source';
import {SourceService} from '../../../../services/source.service';
import {Pagination} from '../../../../../shared/models/Pagination';

@Component({
  selector: 'app-sources',
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.css']
})
export class SourcesComponent extends CrudComponent {
  public paginatedResponse: PaginatedDataResponse<Source> = new PaginatedDataResponse<Source>(0, [], 0, 0, 0);

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private service: SourceService
  ) {
    super(modalService, fb);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null],
      name: ['', [Validators.required]]
    });
    this.formSearch = this.fb.group({
      name: ['']
    });
    this.updateList({page: 1, elements: this.elements});
  }

  onSubmit({value, valid}: { value: Source, valid: boolean }): void {
    if (valid) {
      if (value.id) {
        this.callUpdate(value);
      } else {
        this.callRegister(value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  onFind({value, valid}: { value: any, valid: boolean }): void {
    this.updateList({page: 1, elements: this.elements});
  }

  updateList(pagination: Pagination = {page: 1, elements: this.elements}): void{
    const source: Source = this.formSearch.value;
    this.service.getPaginatedList(pagination.elements, pagination.page, source, this.order).subscribe(
      (response: BaseResponse<PaginatedDataResponse<Source>>) => {
        this.paginatedResponse = response.data;
      }
    );
  }

  openTrashModal(content: TemplateRef<any>, source: Source): void {
    this.modalService.open(content, {ariaLabelledBy: 'appointment-detail-modal-basic-title'}).result.then((result) => {
      this.service.deleteItem(source.id).subscribe(() => this.updateList({page: 1, elements: this.elements}));
    }, (reason) => {
    });
  }

  edit(source: Source): void {
    this.form.setValue(
      {
        id: source.id,
        name: source.name
      }
    );
    this.showHideForm();
  }

  callRegister(source: Source): void {
    this.service.register(source).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }

  callUpdate(source: Source): void {
    this.service.updateItem(source, source.id).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }
}
